import React, { useEffect, useMemo, useState } from "react";
import FromHead from "../../../components/headings/FromHead";
import { FormInput } from "../../../wrappers/formInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { PhoneInput } from "../../../wrappers/phoneInput";
import Styles from "./styles.module.scss";
import Button from "../../../components/button";
import { DropDownInput } from "../../../wrappers/selectInput";

export type ContactDetailsForm = {
  workEmail: string;
  phoneNumber: string;
  companyName: string;
  firstName: string;
  workExp: any;
  designation: string;
};

interface Props {
  defaultValues?: any;
  clickHandler?: any;
  onBlur?: any;
  status?: any;
  fetchCompanyDetails?: any;
}
const validationSchema = Yup.object({
  workEmail: Yup.string()
    .required("Field is required")
    .email("Please provide a valid email address")
    .nullable(true),
  phoneNumber: Yup.string()
    .required("Field is required")
    .min(5, "Invalid Phone Number")
    .max(15, "Invalid Phone Number"),
  companyName: Yup.string().required("Field is required"),
  firstName: Yup.string().required("Field is required"),
});

const Contactdetails: React.FC<Props> = ({
  defaultValues,
  clickHandler,
  onBlur,
  status,
  fetchCompanyDetails,
}) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  };

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm<ContactDetailsForm>(formOptions);

   const [companyFlag, setCompanyFlag] = useState<boolean>(false)

  useEffect(() => {

    if(status === 1){
      setValue('firstName','')
      setValue('phoneNumber','')
      setValue('designation','')
      setValue('companyName','')
    } 
    if(status === 2){   
      if (defaultValues) {
        reset(defaultValues);
      }
    }
    if(status === 3){
      setValue('companyName',defaultValues.companyName)
      setValue('designation',defaultValues.designation)
      setValue('firstName','')
      setValue('phoneNumber','91')
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues, status]);
  
  
  const onSubmitForm = (data: any) => {
    
    localStorage.setItem('email', data.workEmail)
    localStorage.setItem('name', data.firstName)
    data.customerStatus = 1
    clickHandler(data)

  }

  const companyCheck = (event: any) => {
    if (companyFlag) {
      fetchCompanyDetails(event.target.value)
     }
  }
 
  const onBlurCheck = (event: any) => {
    
    let domain = event.target.value.split('@')[1]

    if (domain === 'gmail.com') {
      onBlur(event.target.value)
      setCompanyFlag(true)
    }
    else {
     onBlur(event.target.value)
    }
  }

  return (
    <form>
      <FromHead>What are your contact details?</FromHead>
      <div className="half-form-wrap">
        <div className="form-group">
          <FormInput<ContactDetailsForm>
            id="workEmail"
            type="text"
            name="workEmail"
            label="Work Mail*"
            placeholder="Work Email"
            // defaultValue={email}
            register={register}
            errors={errors}
            onBlur={onBlurCheck}
          />
        </div>
        <div className="form-group">
          <PhoneInput<ContactDetailsForm>
            name="phoneNumber"
            label="Phone Number*"
            register={register}
            errors={errors}
            control={control}
            //  inputProps={register}
          />
        </div>
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <FormInput<ContactDetailsForm>
            id="companyName"
            type="text"
            name="companyName"
            label="Company Name*"
            onBlur={companyCheck}
            placeholder="Company Name*"
            onchange={(e: any) =>
              (e.target.value =
                ("" + e.target.value.charAt(0)).toUpperCase() +
                e.target.value.slice(1))
            }
            register={register}
            errors={errors}
          />
        </div>
        <div className="form-group">
          <FormInput<ContactDetailsForm>
            id="firstName"
            type="text"
            name="firstName"
            label="First Name*"
            placeholder="First Name*"
            onchange={(e: any) =>
              (e.target.value =
                ("" + e.target.value.charAt(0)).toUpperCase() +
                e.target.value.slice(1))
            }
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <DropDownInput<ContactDetailsForm>
            name="designation"
            label="Designation"
            control={control}
            errors={errors}
            register={register}
            data={['Recruiter','C-Level','Manager']}
          />
        </div>
      </div>
      <div className={Styles.privacyPolicy}>
        {/* <div className={Styles.checkbox}>
                <CheckboxDefault/>
              </div> */}
        By submitting this form, I agree with Ellow's{" "}
        <a href="https://www.ellow.io/privacy-policy/">Privacy Policy & <a href="https://www.ellow.io/terms-of-service/">Terms and Conditions</a></a>. I
        understand I can unsubscribe at any time.
      </div>
      <div className={Styles.formAction}>
        <div></div>
        <Button
          variant="primary"
          onClick={handleSubmit(onSubmitForm)}
          disabled={false}
        >
          Now, Add Company Details
        </Button>
      </div>
    </form>
  );
};

export default Contactdetails;
